export default {
    data() {
        return {};
    },
    methods: {
        getCompanyNames(type) {
            axios.get(`/company-names?type=${type}`)
                .then((response) => {
                    this.companyNames = response.data.companyNames;

                }). catch((error) => {
                console.log(error);
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.message,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
            })
        }
    },
};
